import { gql } from '@apollo/client'

const fragments = {
  postList: gql`
    fragment PostList on Post {
      id
      content
      likeCount
      replyCount
      resource {
        uri
        videoId
      }
      resourceType
      createdAt
      artistId
      artist {
        displayName
        avatar {
          uri
        }
        accountId
        patron {
          id
        }
        subscription {
          status
        }
      }
      isLike
      isPremium
    }
  `,
  postDetail: gql`
    fragment PostDetail on Post {
      id
      content
      createdAt
      likeCount
      replyCount
      resourceType
      isPremium
      isLike
      resource {
        uri
        videoId
      }
      artistId
      artist {
        displayName
        avatar {
          uri
        }
        accountId
        patron {
          id
        }
      }
    }
  `,
}

export const {
  GET_POSTS,
  GET_POST_BY_ID,
  GET_REPLIES_BY_POSTID,
  CREATE_POST,
  DELETE_POST,
} = {
  GET_POSTS: gql`
    query($artistId: ID, $pageInput: PageInputDate) {
      artist(id: $artistId) {
        displayName
        avatar {
          uri
        }
        posts(pageInput: $pageInput) {
          edges {
            node {
              ...PostList
            }
          }
          pageInfo {
            hasNextPage
            endCursor
          }
        }
      }
    }
    ${fragments.postList}
  `,
  GET_POST_BY_ID: gql`
    query($id: ID!) {
      post(id: $id) {
        ...PostDetail
      }
    }
    ${fragments.postDetail}
  `,
  GET_REPLIES_BY_POSTID: gql`
    query($id: ID!, $pageInput: PageInputDate) {
      post(id: $id) {
        id
        replies(pageInput: $pageInput) {
          pageInfo {
            hasNextPage
            endCursor
          }
          edges {
            node {
              ... on PostReply {
                id
                createdAt
                content
                responder {
                  ... on User {
                    id
                    displayName
                    accountId
                    avatar {
                      uri
                    }
                  }
                  ... on Artist {
                    id
                    displayName
                    accountId
                    avatar {
                      uri
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  `,
  CREATE_POST: gql`
    mutation($inputs: CreatePostInput!) {
      createPost(inputs: $inputs) {
        ...PostDetail
      }
    }
    ${fragments.postDetail}
  `,
  DELETE_POST: gql`
    mutation($postId: ID!) {
      deletePost(postId: $postId) {
        ...PostDetail
      }
    }
    ${fragments.postDetail}
  `,
}
